import { render, staticRenderFns } from "./payView.vue?vue&type=template&id=5454554e&scoped=true&"
import script from "./payView.vue?vue&type=script&lang=js&"
export * from "./payView.vue?vue&type=script&lang=js&"
import style0 from "./payView.vue?vue&type=style&index=0&id=5454554e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454554e",
  null
  
)

export default component.exports